export enum EnumTypeDocumentUploaded {
  DOCUMENT_UPLOADED = `S`,
  DOCUMENT_NOT_UPLOADED = `N`
}
